<template>
  <div>
    <!-- <div class="loader" v-if="isLoading">
      <CSpinner variant="grow" />
    </div> -->
    <!-- <CCardHeader>
		<CButton color="primary" class="px-4" @click="add()">Add User</CButton>
		<CButton color="primary" class="px-4 pd-r-5" @click="assignModules()">Assign Modules</CButton>
	</CCardHeader> -->

    <CRow>
      <CCol sm="12">
        <CTableWrapper
          :items="getShuffledUsersData()"
          hover
          striped
          bordered
          small
          fixed
          caption="User list"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import CTableWrapper from "./Manage_user.vue";
import axios from "axios";
export default {
  name: "Manage_users",
  components: { CTableWrapper },
  data() {
	  return {
        isLoading: false
	  }
  },
  mounted() {
	  this.isLoading = true;
  },
  methods: {
    getShuffledUsersData() {
      var Session_User_Id = JSON.parse(localStorage.getItem("User_Id"));
      var token = localStorage.getItem("auth");
      var requestInfo = {
        Token: token,
        Session_User_Id: Session_User_Id,
      };
      var data = JSON.stringify(requestInfo);
      var config = {
        method: "post",
        url: apiURL + "ManageUsers/GetUsersList",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      var self = this;
      var usersData = [];
      axios(config)
        .then((result) => {
			setTimeout(() => {
                 this.isLoading = false;
			},2000)
          if (result.data.status_code == 200) {
            var obj = result.data.response;
            var totrow = obj.length;
            for (var i = 0; i < totrow; i++) {
              var row = {
                UserID: obj[i].User_Id,
                Username: obj[i].UserName,
                Email: obj[i].UserEmail,
                Mobile: obj[i].MobileNo,
                status: obj[i].Status,
                action: "Edit",
              };
              usersData.push(row);
            }
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Oops...",
              text: result.data.message,
            });
          }
        })
        .catch((error) => {
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        });
      return usersData;
    },
    shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        let temp = array[i];
        array[i] = array[j];
        array[j] = temp;
      }
      return array;
    },
    add() {
      //console.log('add');
      this.$router.push({ path: "add_users" });
    },
  },
};
</script>
